import { DateTime } from 'luxon';

import { DatesService } from '@common/services';

import { Value, RawValue } from './value';
import { ItemApi, ValueApi } from '../../api/models/historical';
import { FlatItem } from './flat-item';

export class Item
{
    timestamp: number;
    values: Value[];
    dateTime: DateTime;
    rawValues: RawValue[];

    public static mapperFromApi (source: ItemApi): Item
    {
        const target = new Item();

        target.dateTime = DatesService.UtcStringToDateTimeHourStatic(source.dateTime);

        target.values = source.values
            .map((valApi: ValueApi) =>
                new Value(valApi)
            );

        target.rawValues = source.rawValues
            .map((valApi: ValueApi) =>
                new RawValue(valApi)
            );

        target.rawValues = target.values.map((v: Value) =>
        {
            const foundRawValue: RawValue = target.rawValues.find(((rw: RawValue) =>
                rw.channelId === v.channelId
            ));

            return foundRawValue !== undefined ? foundRawValue : new RawValue({
                channel: v.channel,
                channelId: v.channelId,
                value: null
            });
        });

        return target;
    }

    public static flatten (source: Item): FlatItem[]
    {
        const temp = source.values.map((value: Value, idx: number) =>
        {
            const fi = new FlatItem(source.dateTime);
            fi.channel = value.channel;
            fi.channelId = value.channelId;
            fi.unit = value.unit;
            fi.value = value.value;
            fi.rawValue = source.rawValues !== null ? source.rawValues[idx].rawValue : null;

            return fi;
        });

        return temp;
    }
}
